export const LineaCarga = ()=> {
    return(
        <div className="loader">
            <div className="loader__element"></div>
        </div>
    )

}